module.exports = __webpack_public_path__ + "static/media/Montserrat-Regular.6c880721.woff2";